var existingCustomer = localStorage.getItem('ExistingCustomer');
var FreeProductPopup = localStorage.getItem('FreeProduct');

var store_URL = window.location.href;

function ajaxAddToCartCartUpdate(dynamicData) {   

  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: {items:dynamicData},
    dataType: "json",
    success: function(data){ 
      // $('#btnAddtoCart').trigger('click');
    },
    error: function(jqXHR, textStatus, errorThrown) {
      if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
      if(jqXHR.status == 422) { alert(jqXHR.responseJSON.description); }
    }
  });
}

function ajaxAddToCart(dynamicData) {   

  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: {items:dynamicData},
    dataType: "json",
    success: function(data){ 
      $('#cdk-BuyProductGroup').text('Add To Cart');
      window.location.href = "/cart";
    },
    error: function(jqXHR, textStatus, errorThrown) {
      $('#cdk-BuyProductGroup').text('Add To Cart');
      if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
      if(jqXHR.status == 422) { alert(jqXHR.responseJSON.description); }
    }
  });
}

function ajaxAddToCartBogo(dynamicData) {   

  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: {items:dynamicData},
    dataType: "json",
    success: function(data){ 
      //$('#cdk-BuyProductGroup').text('Add To Cart');
      window.location.href = "/checkout?discount=BOGOBUNDLE";
    },
    error: function(jqXHR, textStatus, errorThrown) {
      //$('#cdk-BuyProductGroup').text('Add To Cart');
      if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
      if(jqXHR.status == 422) { alert(jqXHR.responseJSON.description); }
    }
  });
}

//Ajax Add To Cart Function Start
function ajaxAddToCartNew(id, quantity) {
  var dynamicData = "quantity="+quantity+"&id="+id;
  return $.ajax({
    url: "/cart/add.js",
    type: "get",
    data: dynamicData,
    dataType: "json",
    beforeSend: function() {
      //console.log('loading');  
    },
    error: function(jqXHR, textStatus, errorThrown) {
      if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
    }
  });
}
//Ajax Add To Cart Function End 


function ajaxChangeToCartItem(id, quantity) {
  var dynamicData = "quantity="+quantity+"&id="+id;
  return $.ajax({
    url: "/cart/change.js",
    type: "POST",
    data: dynamicData,
    dataType: "json",
    beforeSend: function() {
      //console.log('loading');  
    },
    error: function(jqXHR, textStatus, errorThrown) {
      if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
    }
  });
}
 
$(document).ready(function(){

  $(document).on('click', '.cdk-faq-box .collapsible-trigger', function(){
    $(this).toggleClass('is-open');
    $(this).next('.collapsible-content').toggleClass('is-open').slideToggle();
  })
  // $('#load-more-btn').on('click', function () {
  //   var scrollNode = $('#more').last();
  //   var scrollURL = $('#more p a').last().attr("href");

  //   if (scrollNode.length > 0 && scrollNode.css('display') != 'none') {
  //       // console.log('Load More Clicked');

  //       $.ajax({
  //           type: 'GET',
  //           url: scrollURL,
  //           beforeSend: function () {
  //               $('#load-more-btn').html('<img src=\"//tanaorjewelry.co.il/cdn/shop/t/150/assets/loading.gif?v=158697495679758385951778153957\" />').prop('disabled', true);
  //           },
  //           success: function (data) {
  //               var filteredData = $(data).find('#CollectionAjaxContentAll').find(".grid-product");
  //               var loadmoreData = $(data).find("#more");

  //               $('#more').remove();
  //               filteredData.insertBefore($("#product-list-foot"));
  //               loadmoreData.insertAfter($("#product-list-foot"));

  //               if (loadmoreData.length > 0) {
  //                   $('#load-more-btn').text('פריטים נוספים').prop('disabled', false);
  //               } else {
  //                   $('#load-more-btn').hide();
  //               }
  //           },
  //           dataType: "html"
  //       });
  //   }
  // });
  $(document).on('click', '#load-more-btn', function(){
      var scrollNode = $('#more').last();
      var scrollURL = $('#more p a').last().attr("href");
      if (scrollNode.length > 0 && scrollNode.css('display') != 'none') {
          // console.log('Load More Clicked');
          $.ajax({
              type: 'GET',
              url: scrollURL,
              beforeSend: function () {
                  $('#load-more-btn').html('<img src=\"//tanaorjewelry.co.il/cdn/shop/t/150/assets/loading.gif?v=158697495679758385951778153957\" />').prop('disabled', true);
              },
              success: function (data) {
                  // Find new products in the response
                  var newProducts = $(data).find('#CollectionAjaxContentAll').find(".grid-product");
                  var loadmoreData = $(data).find("#more");
                  
                  // Remove the old "more" section
                  $('#more').remove();
                  
                  // Filter out duplicate products
                  var existingProductIds = [];
                  $('#CollectionAjaxContent .grid-product').each(function() {
                      // Use product URL as unique identifier
                      var productUrl = $(this).find('.grid-product__link').attr('href');
                      if (productUrl) {
                          existingProductIds.push(productUrl);
                      }
                  });
                  
                  // Only append products that don't already exist on the page
                  var uniqueNewProducts = newProducts.filter(function() {
                      var productUrl = $(this).find('.grid-product__link').attr('href');
                      return productUrl && !existingProductIds.includes(productUrl);
                  });
                  
                  // Insert the unique new products
                  uniqueNewProducts.insertBefore($("#product-list-foot"));
                  
                  // Add the new "more" section
                  loadmoreData.insertAfter($("#product-list-foot"));
                  
                  if (loadmoreData.length > 0) {
                      $('#load-more-btn').text('פריטים נוספים').prop('disabled', false);
                  } else {
                      $('#load-more-btn').hide();
                  }
              },
              dataType: "html"
          });
      }
  });

  $(document).on('click', '#CollectionAjaxContent .grid-product__link', function() {
      var scrollPos = $(window).scrollTop();
      var productHref = $(this).attr('href');
      var collectionUrl = window.location.pathname;
      
      sessionStorage.setItem('lastScrollPosition', scrollPos);
      sessionStorage.setItem('lastClickedProduct', productHref);
      sessionStorage.setItem('lastClickedCollection', collectionUrl);
  });
  
  $(document).ready(function() {
      if ($('#CollectionAjaxContent').length > 0) {
          var savedProductHref = sessionStorage.getItem('lastClickedProduct');
          var savedCollectionUrl = sessionStorage.getItem('lastClickedCollection');
          var currentCollectionUrl = window.location.pathname;
          
          // Only proceed if we're on the same collection where the product was clicked

          if (savedProductHref && savedProductHref !== null && savedCollectionUrl && savedCollectionUrl === currentCollectionUrl) {
              
              window.scrollTo(0, 0);
              $(window).scrollTop(0);
              document.documentElement.scrollTop = 0;
              document.body.scrollTop = 0;
              
              setTimeout(function() {
                  findProductAndScrollToIt(savedProductHref);
              }, 2000);
          } else {
              sessionStorage.removeItem('lastClickedProduct');
              sessionStorage.removeItem('lastClickedCollection');
          }
      }
  });
  
  var isLoadingMore = false;
  
  function findProductAndScrollToIt(productHref) {
      if (isLoadingMore) {
          return;
      }
      
      var productLink = $('#CollectionAjaxContent .grid-product__link[href="' + productHref + '"]');
      
      if (productLink.length > 0) {
          $('html, body').animate({
              scrollTop: productLink.offset().top - 100
          }, 500, function() {
              sessionStorage.removeItem('lastClickedProduct');
              sessionStorage.removeItem('lastClickedCollection');
              
              productLink.closest('.grid-product').addClass('highlight-product');
              setTimeout(function() {
                  productLink.closest('.grid-product').removeClass('highlight-product');
              }, 2000);
          });
      } else {
          var loadMoreBtn = $('#load-more-btn');
          
          if (loadMoreBtn.length > 0 && loadMoreBtn.is(':visible') && !loadMoreBtn.prop('disabled')) {
              isLoadingMore = true;
              
              $('html, body').animate({
                  scrollTop: loadMoreBtn.offset().top - 100
              }, 400, function() {
                  loadMoreBtn.trigger('click');
                  
                  var checkBtnInterval = setInterval(function() {
                      if (!$('#load-more-btn').prop('disabled')) {
                          clearInterval(checkBtnInterval);
                          isLoadingMore = false;
                          
                          setTimeout(function() {
                              findProductAndScrollToIt(productHref);
                          }, 400);
                      }
                  }, 200);
              });
          } else {
              sessionStorage.removeItem('lastClickedProduct');
              sessionStorage.removeItem('lastClickedCollection');
          }
      }
  }

  function ScrollExecute() {
    if($(document).height() - 1200 < ($(document).scrollTop() + $(window).height())) {
      scrollNode = $('#more').last();    
      scrollURL = $('#more p a').last().attr("href");
      if(scrollNode.length > 0 && scrollNode.css('display') != 'none') {
        console.log('execute');
        $.ajax({
          type: 'GET',
          url: scrollURL,
          beforeSend: function() {
            scrollNode.clone().empty().insertAfter(scrollNode).append('<img src=\"//tanaorjewelry.co.il/cdn/shop/t/150/assets/loading.gif?v=158697495679758385951778153957\" />');
                                                                      scrollNode.hide();
          },
          success: function(data) {
            // remove loading feedback
            scrollNode.next().remove();
            var filteredData = $(data).find('#CollectionAjaxContentAll').find(".grid-product");
            var loadmoreData = $(data).find("#more");
            $('#more').remove();
            filteredData.insertBefore( $("#product-list-foot") ); 
            loadmoreData.insertAfter( $("#product-list-foot") );
          },
          dataType: "html"
        });
      }
    }
  }


    // $(window).scroll(function(){
    //  ScrollExecute();
    // });
    
    $(document).on('mouseover', '.grid-product .grid-product__content', function(){
      //console.log('hover in');
      var thisHeight = $(this).find('.slideshow-wrapper').height();
      var thisId = $(this).find('.slideshow-wrapper').attr('id');
      var thisdataid = $(this).find('.slideshow-wrapper').attr('data-id')
      var thisslides = $(this).find('.slideshow-wrapper').attr('data-image-count')
      var thisslidesanim = thisslides * 1350;
      //console.log('thisslides::'+thisslides);
      $(this).append("<style>#"+thisId+" .flickity-viewport{height:"+thisHeight+"px; pointer-events:none;} .product-slider.flickity-enabled[data-id='"+thisdataid+"']:after{animation-duration:"+thisslidesanim+"ms}</style>");
    
        $(this).find('.slideshow-wrapper').flickity({
          // options
          draggable: false,
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          prevNextButtons: true,
          autoPlay: 1350, 
        }); 
 
    })

    $(document).on('mouseout', '.grid-product .grid-product__content', function(){
      //console.log('hover Out'); 
      $(this).find('style').remove();
      var $carousel = $(this).find('.slideshow-wrapper').flickity();
      $carousel.flickity('destroy');
    })


// Bundle Code Start
  
  $(document).on('click','.lp_bundle_product_item .lp_bundle_detail .bundle_addbtn', function(){
    var thisId = $(this).parents('.lp_bundle_product_item').attr('var-id');
    var totalComparePrice = parseInt($('.bundle_checkout_box .bundle_price_block .bundle_compare_price').attr('data-total'));
    var totalRegularPrice = parseInt($('.bundle_checkout_box .bundle_price_block .bundle_regular_price').attr('data-total'));
    var thisComparePrice = parseInt($(this).parents('.lp_bundle_product_item').find('.item_compare_price').attr('data-price'));
    var thisRegularPrice = parseInt($(this).parents('.lp_bundle_product_item').find('.item_Price_price').attr('data-price'));
    
    var UptotalComparePrice = totalComparePrice + thisComparePrice;
    var UptotalRegularPrice = totalRegularPrice + thisRegularPrice;
    
    var thisImage = $(this).parents('.lp_bundle_product_item').find('.bundle_prod_image').attr('src');
    var thistitle = $(this).parents('.lp_bundle_product_item').find('.lp_bundle_prod_title').text();
    var thisVal = $(this).parents('.lp_bundle_product_item').find('input').val();
    var thisVal = parseInt(thisVal);
    var thisIncrement = parseInt(thisVal + 1);

    $('.bundle_checkout_box .bundle_price_block .bundle_compare_price').attr('data-total', UptotalComparePrice).text('₪ '+UptotalComparePrice);
    $('.bundle_checkout_box .bundle_price_block .bundle_regular_price').attr('data-total', UptotalRegularPrice).text('₪ '+UptotalRegularPrice);
    // console.log('thisId::'+thisId);
    // console.log('thisImage::'+thisImage);
    // console.log('thistitle::'+thistitle);
    //console.log('thisIncrement::'+thisIncrement);
    $('.bundle-item-wrapper .selected-items').append(' <li data-list-id="'+thisId+'-'+thisIncrement+'"><div class="product" bis_skin_checked="1"><img src="'+thisImage+'"></div><div class="title">"'+thistitle+'"</div><button data-id="'+thisId+'" class="remove-item">x</button></li> ');
    $(this).next('.bty_btn_flex').addClass('selected');
    $(this).parents('.lp_bundle_product_item').find('input').val(thisVal + 1);
    $(this).parents('.lp_bundle_product_item').addClass('selected').attr('data-quantity', thisVal + 1);
    $('.bundle_checkout_box .bundle_price_block .bundle_compare_price').attr('data-total');
    $('.bundle_checkout_box .bundle_price_block .bundle_regular_price').attr('data-total');
    
    var LengthOfItem = $('.bundle_checkout_products .bundle-item-wrapper ul.selected-items li').length;
    var LengthOfItemInc = LengthOfItem +1 ; 
   
    // console.log('thisComparePrice::'+thisComparePrice);
    // console.log('thisRegularPrice::'+thisRegularPrice);
    // console.log('totalComparePrice::'+totalComparePrice);
    // console.log('totalRegularPrice::'+totalRegularPrice);

    console.log('LengthOfItem::'+LengthOfItem);
    if(LengthOfItem >= 3){
      $('.lp-bundle_checkout .bundle-atc').addClass('active'); 
    }
    if(LengthOfItem > 3){
     $('.bundle-item-wrapper .items').append('<li data-index="'+LengthOfItemInc+'"> <div class="product" bis_skin_checked="1">'+LengthOfItemInc+'</div> <div class="title" bis_skin_checked="1">Item '+LengthOfItemInc+'</div> </li>'); 
    } 
  })

  $(document).on('click','.lp_bundle_product_item .lp_bundle_detail .input_btn.plus', function(){
    var thisId = $(this).parents('.lp_bundle_product_item').attr('var-id');
    
    var totalComparePrice = parseInt($('.bundle_checkout_box .bundle_price_block .bundle_compare_price').attr('data-total'));
    var totalRegularPrice = parseInt($('.bundle_checkout_box .bundle_price_block .bundle_regular_price').attr('data-total'));
    var thisComparePrice = parseInt($(this).parents('.lp_bundle_product_item').find('.item_compare_price').attr('data-price'));
    var thisRegularPrice = parseInt($(this).parents('.lp_bundle_product_item').find('.item_Price_price').attr('data-price'));
    
    var UptotalComparePrice = totalComparePrice + thisComparePrice;
    var UptotalRegularPrice = totalRegularPrice + thisRegularPrice;
    
    var thisImage = $(this).parents('.lp_bundle_product_item').find('.bundle_prod_image').attr('src');
    var thistitle = $(this).parents('.lp_bundle_product_item').find('.lp_bundle_prod_title').text();
    var thisVal = $(this).parents('.lp_bundle_product_item').find('input').val();
    var thisVal = parseInt(thisVal);
    var thisIncrement = parseInt(thisVal + 1);

    $('.bundle_checkout_box .bundle_price_block .bundle_compare_price').attr('data-total', UptotalComparePrice).text('₪ '+UptotalComparePrice);
    $('.bundle_checkout_box .bundle_price_block .bundle_regular_price').attr('data-total', UptotalRegularPrice).text('₪ '+UptotalRegularPrice);
    
    // console.log('thisComparePrice::'+thisComparePrice);
    // console.log('thisRegularPrice::'+thisRegularPrice);
    // console.log('totalComparePrice::'+totalComparePrice);
    // console.log('totalRegularPrice::'+totalRegularPrice);
    
    $('.bundle-item-wrapper .selected-items').append(' <li data-list-id="'+thisId+'-'+thisIncrement+'"><div class="product" bis_skin_checked="1"><img src="'+thisImage+'"></div><div class="title">"'+thistitle+'"</div><span data-id="'+thisId+'" class="remove-item">x</span></li> ');
    $(this).next('.bty_btn_flex').addClass('selected');
    $(this).parents('.lp_bundle_product_item').find('input').val(thisVal + 1);
    $(this).parents('.lp_bundle_product_item').addClass('selected').attr('data-quantity', thisVal + 1);
    var LengthOfItem = $('.bundle_checkout_products .bundle-item-wrapper ul.selected-items li').length;
     var LengthOfItemInc = LengthOfItem +1 ; 
    console.log('LengthOfItem::'+LengthOfItem);
    if(LengthOfItem >= 3){
      $('.lp-bundle_checkout .bundle-atc').addClass('active'); 
    }
    if(LengthOfItem > 3){
     $('.bundle-item-wrapper .items').append('<li data-index="'+LengthOfItemInc+'"> <div class="product" bis_skin_checked="1">'+LengthOfItemInc+'</div> <div class="title" bis_skin_checked="1">Item '+LengthOfItemInc+'</div> </li>'); 
    } 
  })

  $(document).on('click','.lp_bundle_product_item .lp_bundle_detail .input_btn.minus', function(){
    var thisId = $(this).parents('.lp_bundle_product_item').attr('var-id');
    var totalComparePrice = parseInt($('.bundle_checkout_box .bundle_price_block .bundle_compare_price').attr('data-total'));
    var totalRegularPrice = parseInt($('.bundle_checkout_box .bundle_price_block .bundle_regular_price').attr('data-total'));
    var thisComparePrice = parseInt($(this).parents('.lp_bundle_product_item').find('.item_compare_price').attr('data-price'));
    var thisRegularPrice = parseInt($(this).parents('.lp_bundle_product_item').find('.item_Price_price').attr('data-price'));
    
    var UptotalComparePrice = totalComparePrice - thisComparePrice;
    var UptotalRegularPrice = totalRegularPrice - thisRegularPrice;
    
    var thisVal = $(this).parents('.lp_bundle_product_item').find('input').val();
    var thisVal = parseInt(thisVal); 
    var LengthOfItem = $('.bundle_checkout_products .bundle-item-wrapper ul.selected-items li').length;
    var LengthOfItemInc = LengthOfItem +1 ; 
    
    $('.bundle_checkout_box .bundle_price_block .bundle_compare_price').attr('data-total', UptotalComparePrice).text('₪ '+UptotalComparePrice);
    $('.bundle_checkout_box .bundle_price_block .bundle_regular_price').attr('data-total', UptotalRegularPrice).text('₪ '+UptotalRegularPrice);
    
    console.log('thisComparePrice::'+thisComparePrice);
    console.log('thisRegularPrice::'+thisRegularPrice);
    console.log('totalComparePrice::'+totalComparePrice);
    console.log('totalRegularPrice::'+totalRegularPrice);
    
    if (!isNaN(thisVal) && thisVal > 1) {
      $('.bundle-item-wrapper .selected-items li[data-list-id="'+thisId+'-'+thisVal+'"]').remove();
      $(this).parents('.lp_bundle_product_item').find('input').val(thisVal - 1);
      $(this).parents('.lp_bundle_product_item').addClass('selected').attr('data-quantity', thisVal - 1);
    }else if(!isNaN(thisVal) && thisVal == 1){
      $('.bundle-item-wrapper .selected-items li[data-list-id="'+thisId+'-'+thisVal+'"]').remove();
      $(this).parents('.lp_bundle_product_item').find('input').val(thisVal - 1);
      $(this).parents('.lp_bundle_product_item').removeClass('selected').attr('data-quantity', 0);
    }
    if(LengthOfItem <= 3){
      $('.lp-bundle_checkout .bundle-atc').removeClass('active');
    }
    if(LengthOfItem > 3){
     $('.bundle-item-wrapper .items li[data-index="'+LengthOfItemInc+'"]').remove(); 
    }
  })

  $(document).on('click','.bundle_checkout_products .bundle-item-wrapper ul.selected-items li .remove-item', function(){
    var thisId = $(this).attr('data-id');
    $('.lp_bundle_container .lp_bundle_row .lp_bundle_product_item[var-id="'+thisId+'"]').find('.input_btn.minus').click();
  })
  


  $(document).on('click' ,'#cdk-BuyProductGroup',function(){
    $(this).text('Please wait...')
    var items = []; 
    $('.lp_bundle_container .lp_bundle_row').find('.lp_bundle_product_item.selected').each(function(){
      var variantId = $(this).attr('var-id'), quantity = $(this).attr('data-quantity');
      if(quantity > 0){items.push({ quantity: quantity,  id: variantId});}
    })
    ajaxAddToCart(items) ;
  });

  $(document).on('click' ,'#cdk-BuyProductBogo',function(){
    $(this).text('מפעיל את ההנחה...')
    var items = []; 
    $('.lp_bundle_container .lp_bundle_row').find('.lp_bundle_product_item.selected').each(function(){
      var variantId = $(this).attr('var-id'), quantity = $(this).attr('data-quantity');
      if(quantity > 0){items.push({ quantity: quantity,  id: variantId});}
    })
    ajaxAddToCartBogo(items) ;
  });

 // if(storedValue == 'true'){
 //    $('#cdk_add_gift_product').addClass('avalable');
 //    $(document).on('click','#cdk_add_gift_product', function(){
 //       var items = []; 
 //        items.push({ quantity: '1',  id: '44149651636453'});
 //        items.push({ quantity: '1',  id: '43804105801957'});
 //        ajaxAddToCartCartUpdate(items);
 //    })
 //    $('#cdkCartCheckoutBtnDrawer').attr('href', '/checkout?discount=DDZBP9T3PNAZ');
 //  }
 if(stored20off == 'true'){
    $('#cdkCartCheckoutBtnDrawer').attr('href', '/checkout?discount=HELLO20');
  }

  

// Bundle code end

 

  $(document).on('click', '.filter-toggle', function(){
    $('.filter-form').toggleClass('active')
  })

                  
  function UpdateProgressBar(){ 
  $.ajax({
    url: '/cart',
    type: 'GET',
    beforeSend: function() {
      
    }
  })
  .done(function(data) {
    // Append data
    $('form#CartDrawerForm .free-shipping').html($(data).find('form#CartDrawerForm').find('.free-shipping').html());
  });

}

    $(document).on('click', '#btnAddtoCart, .rebuy-cart__flyout-item-quantity-widget-button, button.rebuy-button, button.quantity__adjust, button.go3777491745', function(){
      setTimeout(function(){
        UpdateProgressBar();
      },1000)  
    })



  $('.cdk_swatch_first .cdk_swatch_first_item').each(function(){
    var thisFIrstId = $(this).find('.cdk_firstVar_item').attr('data-var-id');
    //console.log('thisFIrstId::'+thisFIrstId);
    $(this).find('.cdk_fp_add_to_cart').attr('var-id', thisFIrstId);
  })

  $(document).on('click', '.cdk_swatch_var', function(){
    $(this).parents('.cdk_swatch_var_main').find('.cdk_swatch_var').removeClass('selected');
    $(this).addClass('selected');
    
    var selectdVar = $(this).attr('data-var-id');
    var selectdVarPrice = $(this).attr('data-var-price');
    var imgIid = $(this).attr('data-var-img');
    //console.log('imgIid::'+imgIid);
    var imgIidIndex = $(this).parents('.grid-product__content').find('[data-img-id="'+imgIid+'"]').attr('data-index');
    
    //console.log('imgIidIndex::'+imgIidIndex);
    $(this).parents('.grid-product__content').find('.flickity-page-dots').find('li:nth-child('+imgIidIndex+')').click();
    $(this).parents('.cdk_swatch_first_item').find('.cdk_fp_add_to_cart').attr('var-id', selectdVar);
     $(this).parents('.grid-product__content').find('.sale-price').text(selectdVarPrice);
    
  })

  $(document).on('click', '.js-qty__num, .quantity__minus, .quantity__plus', function(){
      
      setTimeout(function(){
      var ThisProdGiftId = $('.data_fproduct_Qty_check').attr('data-id');
      var id = $('.data_fproduct_Qty_check').attr('data-id-item')
      var RelatedKQty = $('.data_fproduct_Qty_check').attr('data-qty');
      var RelatedKQty = parseInt(RelatedKQty);
      var ThisGiftQty = $('.data_fproduct_Qty_check').attr('data-this-qty');  
      var ThisGiftQty = parseInt(ThisGiftQty);
        if(ThisGiftQty > RelatedKQty){
          $('.cart__item--qty[data-item-id-btn="'+ThisProdGiftId+'"] .js-qty__num').val(1).change();
          ajaxChangeToCartItem(id, 1).done(function() {
          console.log('test');
          });
        }
      },2000);
       
  })
  
  $(document).on('click', '.quantity__adjust, .js-qty__num, .quantity__plus', function(){
    var checkExist = setInterval(function() {
      if ($('.data_fproduct_remove_true').length) {
        var thisHtml = $('.data_fproduct_remove_true').attr('data-id'); 
        var id = $('.data_fproduct_remove_true').attr('data-id-item'); 
        $('.cart__item--qty[data-item-id-btn="'+thisHtml+'"] .js-qty__num').val(0).change();
          ajaxChangeToCartItem(id, 0).done(function() {
            // console.log('test');
          });
        clearInterval(checkExist);
      }
    }, 2000); 
  })

  setTimeout(function(){
  var thisHtml = $('.data_fproduct_remove_true').attr('data-id'); 
  var id = $('.data_fproduct_remove_true').attr('data-id-item'); 
  console.log('id::'+id);
  if(id == undefined){}
  else{
  
  $('.cart__item--qty[data-item-id-btn="'+thisHtml+'"] .js-qty__num').val(0).change(); 
  ajaxChangeToCartItem(id, 0).done(function() {
      // console.log('test');
  });
  }

  var ThisProdGiftId = $('.data_fproduct_Qty_check').attr('data-id');
  var id = $('.data_fproduct_Qty_check').attr('data-id-item')
  var RelatedKQty = $('.data_fproduct_Qty_check').attr('data-qty');
  var RelatedKQty = parseInt(RelatedKQty);
  var ThisGiftQty = $('.data_fproduct_Qty_check').attr('data-this-qty');  
  var ThisGiftQty = parseInt(ThisGiftQty);
    if(ThisGiftQty > RelatedKQty){
      $('.cart__item--qty[data-item-id-btn="'+ThisProdGiftId+'"] .js-qty__num').val(1).change();
      ajaxChangeToCartItem(id, 1).done(function() {
      console.log('test');
      });
    }
    
  },3000)
  
  var $flicketyCarousel = $('.bundle_popup_slider_container .bundle_popup_slider').flickity();
  $flicketyCarousel.flickity();
  
  $(document).on('click','.bundle_images_zoom_popup .zoom_image_container .close_btn, .bundle_images_zoom_overlay',function(){
    $('html').removeClass('js-drawer-open lock-scroll');
    $('.bundle_images_zoom_popup').removeClass('active');
    $('.bundle_images_zoom_overlay').hide(); 
    $('.bundle_images_zoom_popup .zoom_image_container .bundle_popup_slider_container').html('');
  })
  $(document).on('click','.magnifier_popup_btn',function(){
    var ImagesHtml = $(this).find('.hidden_image').html();
    $('.bundle_images_zoom_popup .zoom_image_container .bundle_popup_slider_container').html(ImagesHtml);
    $('html').addClass('js-drawer-open lock-scroll');
    $('.bundle_images_zoom_popup').addClass('active');
    $('.bundle_images_zoom_overlay').show();
     var $flicketyCarousel = $('.bundle_popup_slider_container .bundle_popup_slider').flickity();
     $flicketyCarousel.flickity();
    
  })

var lastScrollTop = 0;
$(window).scroll(function(event){
  var scrollTop = $(document).scrollTop();
  // console.log('scrollTop::'+scrollTop);
  if(scrollTop > 800){
    $('.sticky_add_to_cart').addClass('active');
    $('body').addClass('sticky-bar-show');
    }else{
      $('.sticky_add_to_cart').removeClass('active');
      $('body').removeClass('sticky-bar-show');
    }
});

  $(document).on('click', '.sticky_add_to_cart .btn_sticky_act', function(){
    $(this).addClass('disabled');
    $('#btnAddtoCart').click();
  })
  $(document).on('click', '.cdk-flex .header__item.navigation ul li a', function(){
    event.preventDefault();
    $("html, body").animate({ scrollTop: $($(this).attr("href")).offset().top }, 500);
  })



  $(document).on('click', '.filter_categories li label', function(){
    $(this).addClass('selected');
    $('.cdk__Filter__loader').fadeIn(100);
    var filter_value = $(this).find('input[type="checkbox"]').val();
    return $.ajax({
      url:  filter_value,
      type: "get",
      success:function(data) {
        $('#CollectionAjaxContentAll').html($(data).find('#CollectionAjaxContentAll').html());
        $('.cdk-filter_collection').html($(data).find('.cdk-filter_collection').html()); 
        window.history.pushState('data', '', filter_value); 
        $('.cdk__Filter__loader').fadeOut(100);
      }
    }); 
  });

  $(document).on('click touchstart', '#clear_all', function(){
    $('.filter_categories li label').removeClass('selected');
    $('.cdk__Filter__loader').fadeIn(100);
    var filter_value = $(this).attr('data-value');
    return $.ajax({
      url:  filter_value,
      type: "get",
      success:function(data) {
        $('#CollectionAjaxContentAll').html($(data).find('#CollectionAjaxContentAll').html());
        $('.cdk-filter_collection').html($(data).find('.cdk-filter_collection').html());
        window.history.pushState('data', '', filter_value); 
        $('.cdk__Filter__loader').fadeOut(100);
      }
    }); 
  });                 
  
var flkty = new Flickity( '.cdk_slider_ab', {
  // options
    cellAlign: 'left',
    wrapAround: true,
    contain: true,
    pageDots: false,
    autoPlay: 5000
});

  $('.testimonials-slider').flickity({
      arrowShape: { 
        x0: 10,
        x1: 55, y1: 50,
        x2: 65, y2: 50,
        x3: 20
      }
  });
  $('.product-single__variants').change(function () {
    var thisvarid = $('.product-single__variants').val();
    //console.log('thisvarid::'+thisvarid);
    var thisPreorder = $(this).find('option[value="'+thisvarid+'"]').attr('data-preorder');
     // var thisDiamond = $(this).find('option[value="'+thisvarid+'"]').attr('data-diamond');
    //console.log('thisPreorder::'+thisPreorder);
    if(thisPreorder == 'true'){
      $('#preorder_input_hidden').html('<input type="hidden" name="properties[Order Type]" value="Pre Order">');
      $('.cdk_preorder_text').text('פריט זה יסופק תוך 20 עד 40 ימי עסקים.').addClass('active_po').show();
      $('[data-add-to-cart-text]').text('הזמנה מוקדמת');
      $('[data-add-to-cart-text]').closest('.add-to-cart').addClass('cdk_preorder_btn');
    }else{
      $('[data-add-to-cart-text]').closest('.add-to-cart').removeClass('cdk_preorder_btn');
      $('#preorder_input_hidden').html('');
      $('.cdk_preorder_text').hide().removeClass('active_po');  
      //  if(thisDiamond == 'true'){
      //   $('.cdk_preorder_text').text('This item is made to order and delivered within 15-20 days.').addClass('active_po').show();
      // }else{
      //   $('.cdk_preorder_text').hide().removeClass('active_po');  
      // } 
      
    }
  })
  
})
 $(document).on("click", ".cover_image .video-play", function () {
      $(this).parents(".cover-img-video").find("video").trigger("play");
      $(this).parents(".cover-img-video").find(".cover_image").hide();
      $(this).parents(".video").siblings().find(".cover-img-video video").trigger("pause");
      $(this).parents(".video").siblings().find(".cover-img-video .cover_image").show();
    });
    $(".video .video-sound").click(function (e) {
      var VideoSoundD = $(this).parents(".cover-img-video").find("video");
      if (VideoSoundD.prop("muted", true)) {
        VideoSoundD.prop("muted", false);
      } else VideoSoundD.prop("muted", false);
      {
        VideoSoundD.prop("muted", true);
      }
    });
    
function isBetween9AMand4PM() {
    const israelDate = new Date().toLocaleString('en-US', {
        timeZone: 'Asia/Jerusalem'
    });
    const israelTime = new Date(israelDate);
    const hours = israelTime.getHours();
    const dayOfWeek = israelTime.getDay();
    // Check if the current time is between 9 AM and 4 PM
    return (dayOfWeek >= 0 && dayOfWeek <= 4) && hours >= 9 && hours < 16;
}

function updatePhoneButtonVisibility() {
    var $phoneButton = $('.cdesk_tel_wrapper');
    var selectedValue = $('.variant-input input[type="radio"]:checked').closest('.variant-input').data('value');

    if (selectedValue) {
        selectedValue = selectedValue.toLowerCase(); 
        // console.log('selectedValue::' + selectedValue);
    }

    // Check if the selected value matches any of the desired values
    if (['golddiamond', 'whitediamond'].includes(selectedValue)) {
        if (isBetween9AMand4PM()) {
            $phoneButton.addClass('active-during-hours');
        } else {
            $phoneButton.removeClass('active-during-hours');
        }
    } else {
        $phoneButton.removeClass('active-during-hours');
    }
}

// Attach event handler to handle changes in selection
$(document).on('change', '.variant-input.color input[type="radio"]', function() {
    updatePhoneButtonVisibility();
});

// Call function on page load to set initial state
$(document).ready(function() {
    updatePhoneButtonVisibility();
});
$(document).on('click', '.learnMoreAbout', function(){
    $('.popup_gift_box_overlay, .popup_gift_box').fadeIn(100);
});

$(document).on('click', '.popup_gift_box .popup_container .popup_close_btn, .popup_gift_box_overlay', function(){
  $('.popup_gift_box_overlay, .popup_gift_box').fadeOut(100);
});

$(document).on('click', '.pdp_video_main_2 .pdp-video-play', function () {
  const $wrapper = $(this).parents('.pdp_video_main_2');
  const $video = $wrapper.find('.pdp-video');
  const $iconPlay = $wrapper.find('.pdp-video-play');
  $video.addClass('active');

  if ($video.length) {
    const videoElement = $video.get(0);
    videoElement.muted = !videoElement.muted;
    videoElement.play();

    if (!videoElement.hasAttribute('controls')) {
      videoElement.setAttribute('controls', 'controls');
    }

    $iconPlay.hide();
  }
});

$(document).ready(function(){

  $(document).on('change', '#cart_product_input_wrap', function() {
    var $cb = $(this);
    var $parent = $cb.closest('.cart_product');
    var $cartItem = $cb.closest('.cdk_cart__item'); // parent cart line

    if (!$cb.prop('checked')) return;

    var variantId = $cb.val();
    if (!variantId) return;

    if ($cb.data('adding')) return;
    $cb.data('adding', true).prop('disabled', true);

    // add loading UI
    $parent.addClass('loading');

    // read timestamp attr from parent cart item (if present)
    var timestampVal = $cartItem.attr('timestamp') || $cartItem.data('timestamp') || '';
    var quantityVal = $cartItem.attr('quatity') || $cartItem.data('quatity') || '';

    // build payload; include properties only when timestamp is available
    var newItem = { id: variantId, quantity: quantityVal };
    if (timestampVal) {
      newItem.properties = { timestamp: timestampVal };
    }

    var items = [ newItem ];

    var jq = $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      data: { items: items },
      dataType: 'json'
    });

    jq.done(function(res) {
      // remove loading class once done (optional here — drawer update may replace DOM)

      if (typeof window.UpdateCartDrawer === 'function') {
        try { window.UpdateCartDrawer(); } catch (e) { console.warn(e); }
        $('[aria-controls="CartDrawer"]').trigger('click');
        return;
      }

      var $trigger = $('[aria-controls="CartDrawer"]');
      if ($trigger.length) {
        $trigger.trigger('click');
      } else {
        $('html').addClass('js-drawer-open lock-scroll');
        $('#CartDrawer').addClass('drawer--is-open');
      }

      $.getJSON('/cart.js', function(cartData) {
        $('.cart-link__bubble-num').text(cartData.item_count);

        if (typeof window.UpdateCartDrawer === 'function') {
          window.UpdateCartDrawer();
        } else {
          $.ajax({
            url: '/',
            type: 'GET',
            dataType: 'html'
          }).done(function(pageHtml) {
            var $parsed = $('<div>').html(pageHtml);
            var newHtml = $parsed.find('#CartDrawerForm').html();
            if (newHtml) {
              $('#CartDrawerForm').html(newHtml);
              if (typeof theme !== 'undefined' && typeof theme.initGlobals === 'function') {
                theme.initGlobals();
              }
            }
          });
        }
      });
    });

    jq.fail(function(xhr, status, err) {
      // remove loading class and revert checkbox
      $parent.removeClass('loading');
      $cb.prop('checked', false);
      alert('לא ניתן להוסיף את המוצר — נסה שוב.');
      console.error('Add to cart failed:', status, err);
    });

    jq.always(function() {
      $cb.prop('disabled', false);
      $cb.data('adding', false);
    });
  });

  // delegated handler so it survives drawer replacements
  $(document).on('click', '.cart-remove-single', function (ev) {
    ev.preventDefault();

    var $btn = $(this);
    // find the cart line wrapper
    var $cartMain = $btn.closest('.cdk_data_main_cart');
    var $cartLine = $btn.closest('.cdk_cart__item');
    if (!$cartLine.length) return;

    var lineKey = $cartLine.attr('data-key') || $cartLine.data('key');
    if (!lineKey) {
      console.error('No data-key found for cart line');
      return;
    }

    // UI: show loading state on the line
    $cartMain.addClass('loading');
    $btn.prop('disabled', true);

    // Shopify change endpoint: send id = line key, quantity = 0 to remove
    $.ajax({
      url: '/cart/change.js',
      method: 'POST',
      data: {
        id: lineKey,
        quantity: 0
      },
      dataType: 'json'
    })
    .done(function (cart) {
      // If you have a global UpdateCartDrawer function use it (preferred)
      if (typeof window.UpdateCartDrawer === 'function') {
        try {
          window.UpdateCartDrawer();
        } catch (err) {
          console.warn('UpdateCartDrawer() threw', err);
        }
        // open drawer like add flow does
        $('[aria-controls="CartDrawer"]').trigger('click');
        // update bubble from returned cart object if present
        if (cart && typeof cart.item_count !== 'undefined') {
          $('.cart-link__bubble-num').text(cart.item_count);
        }
        return;
      }

      // fallback: open drawer and refresh via full page fetch
      var $trigger = $('[aria-controls="CartDrawer"]');
      if ($trigger.length) {
        $trigger.trigger('click');
      } else {
        $('html').addClass('js-drawer-open lock-scroll');
        $('#CartDrawer').addClass('drawer--is-open');
      }

      // update bubble and drawer content using /cart.js + page fetch fallback
      if (cart && typeof cart.item_count !== 'undefined') {
        $('.cart-link__bubble-num').text(cart.item_count);
      } else {
        // try /cart.js to get latest counts
        $.getJSON('/cart.js').done(function (cartData) {
          if (typeof cartData.item_count !== 'undefined') {
            $('.cart-link__bubble-num').text(cartData.item_count);
          }
        });
      }

      // attempt to replace drawer content from server-rendered page
      $.ajax({
        url: '/',
        type: 'GET',
        dataType: 'html'
      }).done(function (pageHtml) {
        var $parsed = $('<div>').html(pageHtml);
        var newHtml = $parsed.find('#CartDrawerForm').html();
        if (newHtml) {
          $('#CartDrawerForm').html(newHtml);
          if (typeof theme !== 'undefined' && typeof theme.initGlobals === 'function') {
            try { theme.initGlobals(); } catch(e){ console.warn(e); }
          }
        } else {
          // as a last resort remove the line from DOM
          $cartLine.remove();
        }
      }).fail(function(){
        // fallback DOM remove if page fetch fails
        $cartLine.remove();
      });
    })
    .fail(function (xhr, status, err) {
      console.error('Remove item failed:', status, err);
      alert('לא ניתן להסיר את המוצר — נסה שוב.'); // keep language consistent with your other alerts
      // clear loading state
      $cartMain.removeClass('loading');
    })
    .always(function () {
      $btn.prop('disabled', false);
    });
  });

});